export namespace StringUtils {

    export function replaceHTMLCharacters(text: string): string {
        // Find HTML tags and replace them with an empty value
        return text.replace(/(<([^>]+)>)/ig, '')
    }

    export function replaceStringAt(str: string, index: number, char: string): string {
        const a = str.split('')
        a[index] = char
        return a.join('')
    }

    export function capitalizeFirstLetter(value: string): string {
        return value.charAt(0).toUpperCase() + value.slice(1)
    }

    export function getNonAlphanumericCharacterCount(text: string): number {
        return text.match(/[^a-zA-Z0-9]/g)?.length ?? 0
    }

    export function removeUnrenderableCharacters(text: string): string {
        const textWithoutHTMLTags = replaceHTMLCharacters(text)
        return textWithoutHTMLTags.replace(/['"&<>/()]/g, '')
    }

    export function parseFormattedNumber(value: string | undefined): number {
        return parseInt(value?.replace(/\D/g, '') || '0', 10)
    }
}
